import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { TIERS } from '../../constants/roles';
import { homesFor } from '../../constants/featureHomes';
import DashboardPage from '../../pages/DashboardPage';
import HomePage from '../../pages/HomePage';
import NoAccessPage from '../../pages/NoAccessPage';

/**
 * What `/` shows (spec 2026-10-06 §4.3): the platform dashboard to Platforms and Admin;
 * a redirect to the one feature a person holds; a card page for several; the no-access
 * page for none. Sits inside ProtectedRoute, so the caller is always signed in.
 */
const LandingRoute = () => {
  const { hasAnyRole } = useAuth();
  if (hasAnyRole(TIERS.PLATFORMS)) return <DashboardPage />;
  const homes = homesFor(hasAnyRole);
  if (homes.length === 0) return <NoAccessPage />;
  if (homes.length === 1) return <Navigate to={homes[0].path} replace />;
  return <HomePage homes={homes} />;
};

export default LandingRoute;
